import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AbstractPaginator } from '../../utils/pagination/abstract-paginator';
import { ClientPaginator } from '../../utils/pagination/client-paginator';
import { ServerPaginator } from '../../utils/pagination/server-paginator';
import { Column, ColumnType, TextColumnFormat } from './column';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  standalone: false
})
export class TableComponent<T> implements OnChanges {
  public readonly TextColumnFormat = TextColumnFormat;
  public readonly ColumnType = ColumnType;
  public readonly dateFormat = 'd MMMM yyyy, h:mm a';

  @Input() public data: T[];
  @Input() public columns: Column<T>[];
  @Input() public editable = false;
  @Input() public deletable = false;
  @Input() public deleteEnabled: (row: T) => boolean = () => true;
  @Input() public loadingMessage = 'This data is loading.';
  @Input() public emptyMessage = 'No data to display.';
  @Input() public error: string;
  @Input() public pages: AbstractPaginator;
  @Output() public readonly edit = new EventEmitter<T>();
  @Output() public readonly delete = new EventEmitter<T>();
  @Output() public readonly page = new EventEmitter();

  public get visibleColumns(): Column<T>[] {
    return this.columns.filter(col => col.visible);
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] && !(this.pages instanceof ServerPaginator)) {
      this.pages = new ClientPaginator(this.data);
    }
  }

  public get rows(): T[] {
    return this.pages instanceof ClientPaginator ?
       this.pages.currentPage : this.data;
  }

  public get headers(): string[] {
    return this.visibleColumns.map(column => column.title);
  }

  public get loading(): boolean {
    return !this.data || !this.pages;
  }

  public get empty(): boolean {
    return this.data && this.pages?.numberElements === 0;
  }

  public preventBubbling(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  public deleteClicked(row: T) {
    if (this.deletable) {
      this.delete.emit(row);
    }
  }

  public editClicked(row: T) {
    if (this.editable) {
      this.edit.emit(row);
    }
  }
}
